/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * ProjectDispatchedRoutesDtoBase
 * auto generated base class for the model ProjectDispatchedRoutesDtoModel.
 *
 * Dispatched routes in project
 */
export const ProjectDispatchedRoutesDtoModelBase = ModelBase
  .named('ProjectDispatchedRoutesDto')
  .props({
    __typename: types.optional(types.literal("ProjectDispatchedRoutesDto"), "ProjectDispatchedRoutesDto"),
    dispatchedCount: types.union(types.undefined, types.integer),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class ProjectDispatchedRoutesDtoModelSelector extends QueryBuilder {
  get dispatchedCount() { return this.__attr(`dispatchedCount`) }
}
export function selectFromProjectDispatchedRoutesDto() {
  return new ProjectDispatchedRoutesDtoModelSelector()
}

export const projectDispatchedRoutesDtoModelPrimitives = selectFromProjectDispatchedRoutesDto().dispatchedCount
